
export const environment = {
    production: false,
    // Auth-M gateway base URL. `ng serve` uses THIS file, so it points at the
    // local gateway. For the deployed dev site, set this to
    // 'https://dev.corelabdiagnostics.com/api'.
    authMUrl: 'https://dev.corelabdiagnostics.com/api',
    authMDevHelpers: false,
    authApiUrl: 'https://dev.corelabdiagnostics.com/user-management',
    apiURL: 'https://dev.corelabdiagnostics.com/user-management',
    baseUrl: 'https://dev.corelabdiagnostics.com',
    filesApiUrl: 'https://dev.corelabdiagnostics.com/api/upload',
    eAtlasApiUrl: 'https://dev.corelabdiagnostics.com/api/imagepedia',
    cdnUrl: 'https://dev.corelabdiagnostics.com/gcs',
    coreApiUrl: 'https://dev.corelabdiagnostics.com/api/core',
    recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
    placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY',
};
